export const BlackDiamondWPHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Sync contacts between Black Diamond and Zocks</li>
        <li>Add or update Black Diamond contacts using insights from meetings, emails, or documents</li>
        <li>Prepare for meetings using data from Zocks, Black Diamond, and your connected systems</li>
        <li>Get instant Black Diamond insights using the Ask Anything AI Assistant</li>
        <li>Auto-fill Zocks forms using portfolio data from Black Diamond</li>
        <li>Generate email replies based on Black Diamond portfolio data — Ultimate subscription tier only</li>
      </ul>
    </div>
  )
}
